import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SportsConfig } from './config'
import { SportTypeValues } from './data_types'

export const initialSportsState: {
  sportsConfig: SportsConfig | null
  selectedSportType: SportTypeValues
} = {
  // Populated at app startup before any consumer reads it.
  sportsConfig: null,
  selectedSportType: 'Soccer'
}

export const sportsSlice = createSlice({
  name: 'sports',
  initialState: initialSportsState,
  reducers: {
    setSportsConfig: (state, action: PayloadAction<SportsConfig>) => {
      state.sportsConfig = action.payload
    },
    setSelectedSportType: (state, action: PayloadAction<SportTypeValues>) => {
      state.selectedSportType = action.payload
    }
  }
})

export const reducer = sportsSlice.reducer

export const { setSportsConfig, setSelectedSportType } = sportsSlice.actions
